import React from "react";
import { Table } from "@culturehq/components";

import { Trans } from "app/utils";

const SurveyTable = ({ displayStatus, children }) => (
  <Table className="SurveyTable">
    <thead>
      <tr>
        <th>
          <Trans>Survey Title</Trans>
        </th>
        <th>
          <Trans>Creator</Trans>
        </th>
        <th>
          <Trans>Score</Trans>
        </th>
        <th>
          <Trans>Questions</Trans>
        </th>
        <th>
          <Trans>Responses</Trans>
        </th>
        {displayStatus && (
          <th>
            <Trans>Status</Trans>
          </th>
        )}
        <th className="actions-cell">
          <Trans>Actions</Trans>
        </th>
      </tr>
    </thead>
    <tbody>{children}</tbody>
  </Table>
);

export default SurveyTable;
